import React from 'react';
import { Link } from '@mui/material';
import { formatFloat } from '../../../../../../helpers';

interface IRevertHintProps {
    hasChanged: boolean;
    original: unknown;
    onRevert: () => void;
}

// Same "hint + explicit click" shape as the transfer form's suggested-amount
// link and the expense subtotal's "apply resources total" link — never
// reverts silently.
export function RevertHint({ hasChanged, original, onRevert }: IRevertHintProps) {
    if (!hasChanged) return null;

    return (
        <>
            {`Valor original: $${formatFloat(Number(original))}`}
            <Link
                component={'button'}
                type={'button'}
                onClick={onRevert}
                sx={{ ml: 1 }}
            >
                Revertir
            </Link>
        </>
    );
}
